
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallets/[id]/other",
      function () {
        return require("private-next-pages/wallets/[id]/other/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallets/[id]/other"])
      });
    }
  